// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Cancellation24Hours48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Cancellation24Hours48: FC<Cancellation24Hours48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="49"
        >
            <path d="M30.493 10a1.915 1.915 0 0 1-1.418-.582 1.95 1.95 0 0 1-.575-1.425c0-.562.194-1.035.582-1.418A1.95 1.95 0 0 1 30.507 6c.562 0 1.035.194 1.418.582.383.388.575.863.575 1.425s-.194 1.035-.582 1.418a1.95 1.95 0 0 1-1.425.575Zm0 33a1.915 1.915 0 0 1-1.418-.582 1.95 1.95 0 0 1-.575-1.425c0-.562.194-1.035.582-1.418A1.95 1.95 0 0 1 30.507 39c.562 0 1.035.194 1.418.582.383.388.575.863.575 1.425s-.194 1.035-.582 1.418a1.95 1.95 0 0 1-1.425.575Zm8-26a1.915 1.915 0 0 1-1.418-.582 1.95 1.95 0 0 1-.575-1.425c0-.562.194-1.035.582-1.418A1.95 1.95 0 0 1 38.507 13c.562 0 1.035.194 1.418.582.383.388.575.863.575 1.425s-.194 1.035-.582 1.418a1.95 1.95 0 0 1-1.425.575Zm0 19a1.915 1.915 0 0 1-1.418-.582 1.95 1.95 0 0 1-.575-1.425c0-.562.194-1.035.582-1.418A1.95 1.95 0 0 1 38.507 32c.562 0 1.035.194 1.418.582.383.388.575.863.575 1.425s-.194 1.035-.582 1.418a1.95 1.95 0 0 1-1.425.575Zm3-9.5a1.915 1.915 0 0 1-1.418-.582 1.95 1.95 0 0 1-.575-1.425c0-.562.194-1.035.582-1.418a1.95 1.95 0 0 1 1.425-.575c.562 0 1.035.194 1.418.582.383.388.575.863.575 1.425s-.194 1.035-.582 1.418a1.95 1.95 0 0 1-1.425.575ZM24 44.5c-2.767 0-5.367-.525-7.8-1.575-2.433-1.05-4.55-2.475-6.35-4.275-1.8-1.8-3.225-3.917-4.275-6.35C4.525 29.867 4 27.267 4 24.5c0-2.767.525-5.367 1.575-7.8 1.05-2.433 2.475-4.55 4.275-6.35 1.8-1.8 3.917-3.225 6.35-4.275C18.633 5.025 21.233 4.5 24 4.5v3c-4.733 0-8.75 1.647-12.05 4.94C8.65 15.735 7 19.755 7 24.5s1.647 8.766 4.94 12.06c3.295 3.293 7.314 4.94 12.06 4.94v3Zm6.6-11.3-8.1-8.1V15h3v8.923l7.2 7.177-2.1 2.1Z" />
        </svg>
    );
};

export default Cancellation24Hours48;
